/* Piklo — front-end behaviour. No dependencies, no build step.
   Shared by the Shopify theme and the static preview. */
(function () {
  'use strict';

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- scroll reveal ------------------------------------------------- */
  var targets = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || reduced) {
    targets.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      /* Stagger by BATCH, not by position in the markup. Everything that
         crosses the line in the same callback entered together — a row of
         tiles, or a whole list caught by a fast flick — so those get spread
         out. An element that arrives on its own is already staggered by the
         scroll itself and gets no delay at all, which is what keeps a slow
         scroll feeling instant instead of laggy. */
      var arriving = entries.filter(function (e) { return e.isIntersecting; });
      arriving.sort(function (a, b) {
        var d = a.boundingClientRect.top - b.boundingClientRect.top;
        return Math.abs(d) > 8 ? d : a.boundingClientRect.left - b.boundingClientRect.left;
      });
      arriving.forEach(function (e, i) {
        e.target.style.setProperty('--i', Math.min(i, 5));
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) { io.observe(el); });

    /* THE BOTTOM OF THE PAGE IS A DEAD ZONE. That -8% bottom margin shrinks
       the observer's root, so anything sitting in the last 8% of the viewport
       never counts as intersecting — and at maximum scroll the LAST element on
       the page is always in it. The footer's copyright row could not be
       reached at all and stayed at opacity 0 on every page. Flush whatever is
       left the moment the page bottoms out. */
    var flush = function () {
      if (scrollY + innerHeight < document.documentElement.scrollHeight - 2) return;
      document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
        el.classList.add('in'); io.unobserve(el);
      });
    };
    addEventListener('scroll', flush, { passive: true });
    addEventListener('resize', flush, { passive: true });
    addEventListener('load', flush);

    /* KEYBOARD FOCUS MUST NEVER LAND ON SOMETHING INVISIBLE. Tab scrolls a
       focused control only as far as the viewport's bottom edge, i.e. into that
       same -8% band, so a short block there never intersects: a closed FAQ row
       (~65px) took focus and sat at opacity 0 until the next Tab. Reveal every
       unrevealed .reveal around the focused element on the spot, with no batch
       delay. (2026-10-20)
       ...AND A KEYBOARD FOCUS LANDS IT AT ONCE, NOT OVER THE SLIDE. The header
       nudge below reads where the control is right after focus: a row 24px
       into its slide was nudged to 89, then slid on to 65, back under the 73px
       header. Every transition still running from the control up to its
       outermost block is finished, which also covers a block the observer
       revealed a moment ago and a slab's children, which carry their own. A
       click keeps the slide: nothing nudges it, and a jump under the pointer
       could cost the click. (2026-10-20) */
    addEventListener('focusin', function (e) {
      var t = e.target, el = t && t.closest ? t.closest('.reveal') : null, top = null;
      while (el) {
        if (!el.classList.contains('in')) {
          el.style.setProperty('--i', 0);
          el.classList.add('in');
          io.unobserve(el);
        }
        top = el;
        el = el.parentElement ? el.parentElement.closest('.reveal') : null;
      }
      if (!top || !byKey || !t.getAnimations) return;   // byKey: set by the header nudge's listeners below
      for (var n = t; ; n = n.parentElement) {   // getAnimations() flushes style, so it sees what .in just started
        n.getAnimations().forEach(function (a) { if (a.transitionProperty) a.finish(); });   // transitions only, never keyframes
        if (n === top) break;
      }
    });
  }

  /* --- sticky header shadow ------------------------------------------ */
  var hdr = document.querySelector('.hdr');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 8); };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- focus never parks under the pinned header (WCAG 2.4.11) ---------
     The header's section wrapper is pinned (piklo-v6.css): 73px of glass over
     the page. Tab and Shift+Tab only scroll a control that is outside the
     viewport, so one already in that band stayed under the glass, and
     Shift+Tab parked rows flush with y 0, wholly hidden. Keyboard focus is
     nudged to 16px below the header instead. Not scroll-padding-top or a focus
     scroll-margin-top: the first made header links jump the page, the second
     also scrolls overflow:hidden boxes (the map, the pinned stage). (2026-10-20) */
  var hdrWrap = document.getElementById('shopify-section-header');
  var byKey = false;   // last input was a key: text fields match :focus-visible on a click too
  addEventListener('keydown', function () { byKey = true; }, true);
  addEventListener('pointerdown', function () { byKey = false; }, true);
  function clearHeader(t) {
    if (!hdrWrap || !t || !t.getBoundingClientRect || hdrWrap.contains(t)) return;   // header + drawer
    if (t.closest('.ann, .stage4.is-js, .buybar, a.sr')) return;   // above it / scroll-driven stage / fixed bar / fixed skip link
    var r = t.getBoundingClientRect(), hb = hdrWrap.getBoundingClientRect().bottom;
    if (r.height > innerHeight - hb - 24) return;                  // taller than the band: leave it
    if (r.top < hb + 8) window.scrollBy(0, r.top - hb - 16);
  }
  addEventListener('focusin', function (e) {
    var t = e.target;
    // not requestAnimationFrame: it was starved past the next keypress and a
    // stop stayed hidden. By this task the browser's own focus scroll is done.
    setTimeout(function () {
      if (!byKey || document.activeElement !== t) return;            // a click or tap never moves the page
      try { if (!t.matches(':focus-visible')) return; } catch (x) {}
      clearHeader(t);
    }, 0);
  });

  /* --- rotating announcement -----------------------------------------
     WCAG 2.2.2: it moves on its own, so it has to stop on demand. It holds
     while a mouse is over the bar or a message link has keyboard focus, sits
     out a background tab, and the pause button stops it until pressed again.
     Three separate flags: with one shared flag, moving the mouse off the bar
     after pressing pause would have restarted it. It used to run on an
     unconditional interval with no way to stop it. (2026-10-20) */
  var annItems = document.querySelectorAll('.ann__item');
  if (annItems.length > 1 && !reduced) {
    var ai = 0, annTimer = null, annHover = false, annFocus = false, annStopped = false;
    var annBar = annItems[0].closest('.ann');
    var annBtn = annBar && annBar.querySelector('.ann__pause');
    var annSync = function () {
      var run = !annStopped && !annHover && !annFocus && !document.hidden;
      if (run && !annTimer) {
        // restarted, not resumed: the message just read gets a full 4.2s
        annTimer = setInterval(function () {
          annItems[ai].classList.remove('is-on');
          ai = (ai + 1) % annItems.length;
          annItems[ai].classList.add('is-on');
        }, 4200);
      } else if (!run && annTimer) {
        clearInterval(annTimer);
        annTimer = null;
      }
    };
    if (annBar) {
      // a mouse only: a tap leaves a sticky hover behind on phones
      annBar.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') { annHover = true; annSync(); }
      });
      annBar.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') { annHover = false; annSync(); }
      });
      // focus on the pause button itself does not hold it, or pressing it
      // again to resume would change nothing until focus moved away
      var annHold = function (el) {
        annFocus = !!el && el !== annBtn && annBar.contains(el);
        annSync();
      };
      annBar.addEventListener('focusin', function (e) { annHold(e.target); });
      annBar.addEventListener('focusout', function (e) { annHold(e.relatedTarget); });
    }
    document.addEventListener('visibilitychange', annSync);
    if (annBtn) {
      annBtn.hidden = false;
      annBtn.addEventListener('click', function () {
        annStopped = !annStopped;
        annBtn.setAttribute('aria-pressed', annStopped ? 'true' : 'false');
        annSync();
      });
    }
    annSync();
  }

  /* --- mobile drawer --------------------------------------------------
     A modal while open: everything outside it goes inert, so Tab and a screen
     reader stay inside, and focus moves to Close and later back to the burger.
     It used to toggle the class and nothing else: focus stayed behind it and
     Tab walked out into the covered page. Closed, piklo-v6.css hides it.
     (2026-10-19) */
  var drawer = document.querySelector('.drawer');
  var drawerFrom = null;   // the burger that opened it
  var drawerInert = [];    // what openDrawer made inert, and only that
  function openDrawer(btn) {
    if (!drawer || drawer.classList.contains('is-open')) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawerFrom = btn;
    btn.setAttribute('aria-expanded', 'true');
    /* Every sibling on the way up to <body>. Not the header's whole section:
       the drawer lives in it, so there only .hdr goes inert. Browsers without
       inert still open and close it, just without the trap. */
    for (var n = drawer; n !== document.body && n.parentElement; n = n.parentElement) {
      [].forEach.call(n.parentElement.children, function (el) {
        if (el === n || el.tagName === 'SCRIPT' || el.inert) return;
        el.inert = true;
        drawerInert.push(el);
      });
    }
    var x = drawer.querySelector('[data-drawer-close]');
    if (x) x.focus();
  }
  /* restore: focus back to the burger. Not after a link: it navigates or jumps
     to an anchor (/#buy), and pulling focus up to the header would fight that. */
  function closeDrawer(restore) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    drawerInert.forEach(function (el) { el.inert = false; });
    drawerInert = [];
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (restore && drawerFrom) drawerFrom.focus({ preventScroll: true });
    drawerFrom = null;
  }
  document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function () { openDrawer(b); });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
    b.addEventListener('click', function () { closeDrawer(b.tagName !== 'A'); });
  });
  addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer(true);
  });

  /* --- hero bubbles ---------------------------------------------------- */
  var art = document.querySelector('[data-bubbles]');
  if (art && !reduced) {
    for (var i = 0; i < 14; i++) {
      var b = document.createElement('span');
      var size = 6 + Math.round(Math.random() * 20);
      b.className = 'bub';
      b.style.width = b.style.height = size + 'px';
      b.style.left = Math.round(Math.random() * 88) + '%';
      b.style.bottom = Math.round(Math.random() * 30) + '%';
      b.style.animationDuration = (5 + Math.random() * 6).toFixed(1) + 's';
      b.style.animationDelay = (Math.random() * 6).toFixed(1) + 's';
      art.appendChild(b);
    }
  }

  /* --- variant pickers -------------------------------------------------
     Every option button carries data-price / data-unit / data-available and,
     in the Shopify theme, data-variant-id. Selecting one updates the price
     display, the hidden variant input and the submit button state.          */
  /* --- the nutrition panel collapses on phones --------------------------------
     It ships `open` so desktop, no-JS and crawlers get the whole transcription;
     only a small screen closes it. Nothing is removed from the page. */
  (function () {
    var reveal = document.querySelector('[data-panel-reveal]');
    if (reveal && matchMedia('(max-width: 760px)').matches) reveal.removeAttribute('open');
  })();

  /* --- live cart -----------------------------------------------------------
     The quantity stepper talks to /cart/change.js and swaps this section's
     re-rendered HTML back in (Shopify's Section Rendering API). That keeps ONE
     source of truth for the line totals, the subtotal and the free-shipping
     meter: the Liquid. Re-implementing that maths in JS is how the two drift.

     No JS: the form still posts and the Update button still works, which is why
     the button is hidden here rather than deleted from the markup. */
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var coarse = matchMedia('(pointer: coarse)');

  /* The header cart link, badge AND aria-label: the label used to keep its
     page-load count forever. The badge is only in the markup when the count is
     above 0, so it is made on demand, and .cart-count is display:grid, so the
     `hidden` attribute would not hide it; the inline style does. */
  function paintCartCount(n) {
    var link = document.querySelector('[data-cart-link]');
    if (!link || !(n >= 0)) return;
    var c = link.querySelector('.cart-count');
    if (!c && n > 0) {
      c = document.createElement('span');
      c.className = 'cart-count';
      link.appendChild(c);
    }
    if (c) {
      c.textContent = n;
      c.style.display = n > 0 ? '' : 'none';
    }
    link.setAttribute('aria-label', (link.getAttribute('data-label') || 'Cart') + ' (' + n + ')');
  }

  /* Read out what a cart change did. The status line sits OUTSIDE the section:
     one inside it would be replaced by every swap, and a live region that
     arrives already holding its words is not read out. Emptied first and filled
     a beat later, so the same words twice are still announced. */
  function announce(text) {
    var live = document.getElementById('cart-live');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }

  /* A press on Check out that has not become a click yet. A swap in between
     replaces the button under the finger, the click lands on the wrapper and
     checkout never starts, so a swap waits for the click (1.5s at most). */
  var checkoutPress = 0;
  if (document.querySelector('[data-cart-section]')) {
    addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('[data-cart-section] [name="checkout"]')) checkoutPress = Date.now();
    }, true);
    addEventListener('click', function () { checkoutPress = 0; }, true);
    addEventListener('pointercancel', function () { checkoutPress = 0; }, true);
  }
  function whenReleased(fn) {
    if (checkoutPress && Date.now() - checkoutPress < 1500) {
      setTimeout(function () { whenReleased(fn); }, 40);
      return;
    }
    fn();
  }

  /* Swap freshly rendered cart HTML in for the section on screen. Returns the
     new root, or null when the HTML holds no cart. */
  function swapCart(html) {
    var root = document.querySelector('[data-cart-section]');
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
    if (!root || !next) return null;

    /* The swap destroys whatever had focus, and focus fell to <body>: the next
       Tab restarted at the top of the page. Note which control on which item,
       so its counterpart can take focus back. */
    var a = document.activeElement, spot = null;
    if (a && a !== document.body && root.contains(a)) {
      var row = a.closest('[data-cart-line]');
      spot = {
        key: row ? row.getAttribute('data-key') : null,
        line: row ? parseInt(row.getAttribute('data-cart-line'), 10) : 0,
        sel: a.hasAttribute('data-step') ? '[data-step="' + a.getAttribute('data-step') + '"]'
           : a.hasAttribute('data-cart-remove') ? '[data-cart-remove]'
           : a.getAttribute('name') ? '[name="' + a.getAttribute('name') + '"]'
           : a.classList.length ? '.' + a.classList[0] : null
      };
    }

    root.replaceWith(next);

    /* The swapped-in markup is FRESH Liquid, so every `.reveal` in it is
       back at opacity 0 and the observer that would switch them on only
       ever saw the nodes that existed at page load. Without this the cart
       heading, the free-shipping meter, the line items and the totals all
       go invisible the moment you change a quantity — the page looks
       broken and only a reload brings it back.

       They are shown INSTANTLY rather than re-observed: this content was
       already on screen a moment ago, and fading it back in on every
       quantity change would be a flicker, not an entrance. */
    if (next.classList.contains('reveal')) next.classList.add('in');
    next.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    paintCartCount(parseInt(next.getAttribute('data-cart-count'), 10));
    bindLiveCart();     // the swapped-in markup needs its own handlers

    if (spot) {
      // the same control on the same item; if the item went, the line that took
      // its place (or the last one); if the cart emptied, the heading
      var rows = next.querySelectorAll('[data-cart-line]'), t = null;
      if (spot.line) {
        for (var i = 0; i < rows.length; i++) {
          if (spot.key && rows[i].getAttribute('data-key') === spot.key) {
            t = (spot.sel && rows[i].querySelector(spot.sel)) || rows[i].querySelector('[data-cart-qty] input');
          }
        }
        if (!t && rows.length) t = rows[Math.min(spot.line, rows.length) - 1].querySelector('[data-cart-qty] input');
      } else if (spot.sel) {
        t = next.querySelector(spot.sel);
      }
      if (!t) t = next.querySelector('h1');
      if (t && t.tagName === 'H1') t.setAttribute('tabindex', '-1');
      // it may sit under the pinned header, or above the screen once the page shrank
      if (t) { t.focus({ preventScroll: true }); clearHeader(t); }
    }
    return next;
  }

  /* Redraw the cart from the server, for a page known to be stale: one brought
     back by Back/Forward, or one whose write just failed. Nothing on it writes
     meanwhile (is-syncing); `msg`, when there is one, is shown and read out.
     If the redraw fails too, reload, which is blunt but always recovers. */
  function resyncCart(msg) {
    var root = document.querySelector('[data-cart-section]');
    if (!root) return;
    root.classList.add('is-syncing');
    fetch(shopRoot + 'cart?section_id=' + encodeURIComponent(root.getAttribute('data-cart-section')),
          { cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.text();
      })
      .then(function (html) {
        whenReleased(function () {
          var next = swapCart(html);
          if (!next) { location.reload(); return; }
          var box = msg ? next.querySelector('[data-cart-msg]') : null;
          if (box) { box.textContent = msg; box.hidden = false; }
          if (msg) announce(msg);
        });
      })
      .catch(function () { location.reload(); });
  }

  function bindLiveCart() {
    var root = document.querySelector('[data-cart-section]');
    if (!root) return;
    var sectionId = root.getAttribute('data-cart-section');
    var busy = false;
    /* Writes asked for while one is in flight: one per item, latest number wins,
       held by line-item KEY because a removal in flight renumbers every line
       after it. */
    var queue = [];

    // JS is live, so the manual Update button is redundant
    var actions = root.querySelector('[data-cart-actions]');
    if (actions) actions.classList.add('is-live');

    // the status line announce() writes to: made once, outside anything a swap replaces
    if (!document.getElementById('cart-live')) {
      var live = document.createElement('p');
      live.id = 'cart-live';
      live.className = 'sr';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }

    function change(line, qty) {
      if (root.classList.contains('is-syncing')) return;   // stale and being redrawn: not the real cart
      if (busy) {
        // queue it rather than drop it: a quick second tap used to vanish
        var row = root.querySelector('[data-cart-line="' + line + '"]');
        var key = row && row.getAttribute('data-key');
        if (!key) return;
        queue = queue.filter(function (q) { return q.key !== key; });
        queue.push({ key: key, qty: qty });
        return;
      }
      busy = true;
      root.classList.add('is-busy');
      var msg = root.querySelector('[data-cart-msg]');
      if (msg) msg.hidden = true;      // an earlier failure no longer applies
      send(line, qty);
    }

    function send(line, qty) {
      /* A stalled request would otherwise hold `busy` forever and leave the
         quantity controls dead with no way back. Abort at 10s; the catch below
         redraws the cart from the server. */
      var ctl = ('AbortController' in window) ? new AbortController() : null;
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, 10000) : 0;
      fetch(shopRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: sectionId, sections_url: '/cart' }),
        signal: ctl ? ctl.signal : undefined
      })
        .then(function (r) {
          /* A non-2xx can still carry a JSON body, and a 5xx carries HTML that
             blows up .json() — either way the old code treated both as success
             and only the parse error saved it. Check the status explicitly.
             A refusal explains itself ("Only 50 items were added to your cart
             due to availability."), so keep its words for the shopper. */
          if (r.ok) return r.json();
          return r.json().catch(function () { return {}; }).then(function (b) {
            var err = new Error('cart ' + r.status);
            err.userMsg = b && typeof b.description === 'string' ? b.description : '';
            throw err;
          });
        })
        .then(function (data) {
          clearTimeout(timer);
          /* Queued writes go first, and the page is redrawn ONCE, from the last
             answer: a redraw in between would put the server's number back in a
             box that a queued tap was counted from. */
          var items = (data && data.items) || [];
          for (var q = queue.shift(); q; q = queue.shift()) {
            for (var i = 0; i < items.length; i++) {
              if (items[i].key === q.key) { send(i + 1, q.qty); return; }
            }
            // that item went meanwhile (removed): its queued tap goes with it
          }
          var html = data && data.sections && data.sections[sectionId];
          if (!html) { location.reload(); return; }
          whenReleased(function () {
            var next = swapCart(html);
            if (!next) { location.reload(); return; }
            var sub = next.querySelector('.cartx__grand');
            var ship = next.querySelector('.cartx__shiptop b');
            announce(!sub ? 'Your cart is empty.'
              : 'Cart updated. Subtotal ' + sub.textContent.trim() + '.' +
                (ship ? ' ' + ship.textContent.trim().replace(/([^.!?])$/, '$1.') : ''));
          });
        })
        .catch(function (err) {
          clearTimeout(timer);
          /* A refusal, a 5xx, a dropped connection or the 10s abort. This used
             to be a silent reload that threw Shopify's explanation away. Put the
             last confirmed numbers back in the boxes, redraw from the real cart
             and say what happened. */
          queue = [];
          busy = false;
          root.classList.remove('is-busy');
          root.querySelectorAll('[data-cart-qty] input').forEach(function (el) { el.value = el.defaultValue; });
          resyncCart((err && err.userMsg) || root.getAttribute('data-cart-error-text') || '');
        });
    }

    /* The "add N more and shipping is free" nudge is a plain link to
       /cart/change, so clicking it NAVIGATES. If a stepper request is still in
       flight, the navigation and the AJAX write race: the page renders one
       quantity and the AJAX response then writes a different one, leaving the
       cart on screen disagreeing with the real cart until a manual reload.
       That is the "I added a 4-pack and my whole order disappeared" bug.

       Send it through the same single path as everything else. The href stays
       as the no-JS fallback. */
    var nudge = root.querySelector('.cartx__nudge');
    if (nudge) {
      nudge.addEventListener('click', function (e) {
        var href = nudge.getAttribute('href') || '';
        var ln = href.match(/[?&]line=(\d+)/);
        var qn = href.match(/[?&]quantity=(\d+)/);
        if (!ln || !qn) return;                 // unrecognised: let it navigate
        e.preventDefault();
        if (busy) return;                       // its number predates the write in flight; the redraw brings a fresh one
        change(parseInt(ln[1], 10), parseInt(qn[1], 10));
      });
    }

    root.querySelectorAll('[data-cart-line]').forEach(function (row) {
      var line = parseInt(row.getAttribute('data-cart-line'), 10);
      var input = row.querySelector('[data-cart-qty] input');
      var asked = input ? input.value : '';     // the number this box last asked the cart for
      row.querySelectorAll('[data-cart-qty] [data-step]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();          // do not let the generic stepper also fire
          // count from the box: it already holds any tap still in flight
          var q = parseInt(input.value, 10);
          if (isNaN(q)) q = parseInt(asked, 10) || 0;
          q = btn.getAttribute('data-step') === 'up' ? q + 1 : Math.max(0, q - 1);
          input.value = asked = String(q);
          change(line, q);
        }, true);
      });
      if (input) {
        /* A typed number. A blank (or negative) box used to count as 0 and
           remove the line; it now gets its number back. Only an explicit 0, the
           minus at 1 or Remove deletes. The same number again sends nothing. */
        var commit = function () {
          var v = parseInt(input.value, 10);
          if (isNaN(v) || v < 0 || String(v) === asked) { input.value = asked; return; }
          input.value = asked = String(v);
          change(line, v);
        };
        input.addEventListener('change', commit);
        /* Enter submitted the form through its default button, Check out, while
           'change' sent its own write: two racing cart writes and a trip to
           checkout. Apply the number here instead. On a phone, Done should
           close the keyboard, so blur (commit has run, so the blur sends
           nothing); a keyboard user keeps focus in the box. */
        input.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          commit();
          if (coarse.matches) input.blur();
        });
      }
      var remove = row.querySelector('[data-cart-remove]');
      if (remove) {
        remove.addEventListener('click', function (e) { e.preventDefault(); change(line, 0); });
      }
    });
  }
  bindLiveCart();

  /* Back/Forward can put a stale cart on screen. Shopify sends pages `private,
     max-age=0, must-revalidate`, not no-store, so without the back/forward
     cache Chrome rebuilds the page from its HTTP cache (the HTML from before the
     last change), and with it the frozen page comes back as it was left. Either
     way it predates what happened since, a stepper tap or an add elsewhere. The
     stepper writes ABSOLUTE numbers, so a tap on that page undid a real change,
     and its Check out posted the old ones. Ask the server again: on /cart
     redraw the section, anywhere else repaint the header count. Ordinary loads
     skip this, and a reload is not a history visit, so the reload fallback
     cannot loop. Checked at load as well as on pageshow so the stale page is
     locked from the start, not from the load event. */
  function freshenCart() {
    if (document.querySelector('[data-cart-section]')) { resyncCart(''); return; }
    if (!document.querySelector('[data-cart-link]')) return;
    fetch(shopRoot + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) paintCartCount(d.item_count); })
      .catch(function () {});
  }
  var navEntry = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  if (navEntry ? navEntry.type === 'back_forward'
               : performance.navigation && performance.navigation.type === 2) freshenCart();
  addEventListener('pageshow', function (e) { if (e.persisted) freshenCart(); });   // back/forward cache

  document.querySelectorAll('[data-picker]').forEach(function (group) {
    var scope = group.closest('[data-buy]') || document;
    var priceEl = scope.querySelector('[data-price-out]');
    var unitEl = scope.querySelector('[data-unit-out]');
    var idInput = scope.querySelector('[data-variant-input]');
    var submit = scope.querySelector('[data-submit]');
    // The PDP's "Skip the cart" link checks out one fixed size, so it shows only
    // while that size is the pick: under a picked single can it checked out a
    // 12 pack. It sits outside the ticket, so it is found from the page wrapper,
    // not `scope`; a picker anywhere else has no such link.
    var pdpIn = group.closest('.pdp__in');
    var express = pdpIn && pdpIn.querySelector('.pdp__express[data-express-id]');

    group.querySelectorAll('[data-opt]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (opt.hasAttribute('disabled')) return;
        // aria-pressed moves with is-on: the class alone is invisible to a screen reader
        group.querySelectorAll('[data-opt]').forEach(function (o) {
          o.classList.remove('is-on');
          o.setAttribute('aria-pressed', 'false');
        });
        opt.classList.add('is-on');
        opt.setAttribute('aria-pressed', 'true');

        if (priceEl) priceEl.textContent = opt.dataset.price || '';
        if (unitEl) unitEl.textContent = opt.dataset.unit || '';
        if (idInput) idInput.value = opt.dataset.variantId || '';
        if (express) express.hidden = opt.dataset.variantId !== express.dataset.expressId;

        // The free-shipping line answers the CURRENT selection: on the 12 pack it
        // confirms shipping is free, on the smaller tiers it says what is still
        // short. The threshold is $32 (2026-10-07) and the 12 pack is the only
        // size that reaches it on its own. All tiers return to the cart, where
        // the meter closes the gap for the smaller two.
        // The wording itself lives in Liquid (data-ship) so it stays in one place.
        var retInput = scope.querySelector('[data-return-to]');
        if (retInput && opt.dataset.returnTo) retInput.value = opt.dataset.returnTo;

        var shipEl = scope.querySelector('[data-ship-out]');
        if (shipEl && opt.dataset.ship) {
          shipEl.textContent = opt.dataset.ship;
          shipEl.classList.toggle('is-won', opt.dataset.shipWon === 'true');
        }

        // Every tier is now its own Shopify variant at qty 1, but the option still
        // carries its line quantity so a multi-unit tier can be reintroduced
        // without touching this handler.
        var qtyInput = scope.querySelector('[data-qty-input]');
        if (qtyInput && opt.dataset.qty) qtyInput.value = opt.dataset.qty;

        if (submit) {
          var ok = opt.dataset.available === 'true';
          submit.disabled = !ok;
          submit.textContent = ok ? (submit.dataset.labelAdd || 'Add to cart')
                                  : (submit.dataset.labelOut || 'Sold out');
        }
      });
    });
  });

  /* --- quantity steppers ------------------------------------------------
     `:not([data-cart-qty])` is load-bearing. The CART stepper carries BOTH
     attributes, so it was bound twice: once here and once by bindLiveCart.
     This one clamps at a minimum of 1, which meant the minus button could
     never reach 0 and an item could not be removed with it — and the two
     handlers raced over the same input value. The cart has its own stepper;
     this is only for the product form. */
  document.querySelectorAll('[data-qty]:not([data-cart-qty])').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'up' ? 1 : -1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
      });
    });
  });

  /* --- sticky buy bar ---------------------------------------------------
     Appears once the primary buy section has scrolled past, so the offer is
     never more than one tap away. [data-buybar] is the bar, [data-buybar-after]
     is the element whose exit triggers it.                                   */
  var buybar = document.querySelector('[data-buybar]');
  var buybarAfter = document.querySelector('[data-buybar-after]');
  // The footer opens with its own call to action. Once that band is on screen
  // the bar has nothing left to add, and it was sitting on top of the band's
  // two buttons — so it steps aside there. (2026-10-16)
  // With no band (its heading left blank) the bar steps aside when the footer
  // arrives instead: there is no body padding reserve any more, so nothing else
  // would let the copyright strip scroll clear of it. (2026-10-20)
  var buybarEnd = document.querySelector('.ftr__cta') || document.querySelector('.ftr');
  if (buybar && buybarAfter) {
    // A positional check, NOT IntersectionObserver: IO only fires on threshold
    // CROSSINGS, so an instant jump (anchor link, restored scroll) that never
    // intersects the section would leave the bar permanently off.
    var barTick = false;
    var barCheck = function () {
      if (barTick) return;
      barTick = true;
      requestAnimationFrame(function () {
        var past = buybarAfter.getBoundingClientRect().bottom < 0;
        var atEnd = !!buybarEnd && buybarEnd.getBoundingClientRect().top < innerHeight - 40;
        buybar.classList.toggle('is-on', past && !atEnd);
        barTick = false;
      });
    };
    addEventListener('scroll', barCheck, { passive: true });
    addEventListener('resize', barCheck);
    barCheck();
  }

  /* --- preview-only add feedback ----------------------------------------
     Buttons without a real form (the static preview) get a visible "Added"
     state and bump the cart count, so the demo behaves instead of playing
     dead. Real carting is Shopify's form submit in the theme.               */
  document.querySelectorAll('[data-submit]').forEach(function (btn) {
    if (btn.closest('form')) return;                  // theme: real submit
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var label = btn.textContent;
      btn.textContent = 'Added \u2713';
      document.querySelectorAll('.cart-count').forEach(function (c) {
        c.textContent = (parseInt(c.textContent, 10) || 0) + 1;
      });
      setTimeout(function () { btn.textContent = label; }, 1400);
    });
  });

  /* --- add-to-cart double-submit guard ---------------------------------------
     Every product form is a native POST to /cart/add. A second click or tap
     before the page unloads posts again: the browser aborts the first request,
     but Shopify has already added it, so the cart gets BOTH (a double-clicked
     12 pack became two). Once one submit is under way, drop the rest.

     NOT .disabled — the picker owns that for sold out, and a disabled submitter
     drops out of the posted form data. aria-disabled + the busy flag do it; the
     10s timer and back/forward-cache restores hand the button back. */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    var btn = form.querySelector('button[type="submit"]');
    var idle = '';
    var timer = 0;
    function reset() {
      clearTimeout(timer);
      delete form.dataset.busy;
      if (btn && btn.getAttribute('aria-disabled') === 'true') {
        btn.removeAttribute('aria-disabled');
        // a tier picked meanwhile has rewritten the label (maybe to sold out): keep it
        if (btn.textContent === 'Adding…') btn.textContent = idle;
      }
    }
    form.addEventListener('submit', function (e) {
      if (form.dataset.busy || (btn && btn.disabled)) { e.preventDefault(); return; }
      form.dataset.busy = '1';
      if (btn) {
        idle = btn.textContent;
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Adding…';
      }
      timer = setTimeout(reset, 10000);   // a stalled or stopped navigation must not lock it
    });
    addEventListener('pageshow', function (ev) { if (ev.persisted) reset(); });   // back/forward cache
  });

  /* --- after the contact form posts ---------------------------------------
     Shopify posts the contact form to `/contact#PikloContact` and the browser
     jumps to that id on the response. On success the form collapses to a short
     confirmation, so the page is ~400px shorter than the one you submitted
     from — the browser cannot scroll far enough to put the anchor at the top,
     clamps at the maximum, and you land at the very bottom of the page having
     never seen the message. That is the "it teleports me to the bottom".

     So put the confirmation where it can actually be read, and do it before
     paint so there is no visible second jump. */
  (function () {
    var sent = document.querySelector('.ctc__sent');
    if (!sent) return;
    var park = function () {
      var top = sent.getBoundingClientRect().top + window.pageYOffset;
      var y = Math.max(0, top - Math.round(innerHeight * 0.32));
      window.scrollTo(0, y);
    };
    park();
    // fonts and images settle after first paint and move it again
    addEventListener('load', park);
    setTimeout(park, 300);
  })();

  /* --- form bot traps ----------------------------------------------------
     Shopify already runs hCaptcha on storefront forms, and THAT is the real
     protection because it is enforced server-side. These two traps sit in
     front of it and cost a real visitor nothing:

       1. a honeypot field a person never sees and a form-filler always fills
       2. a minimum time on the form — a bot submits in milliseconds

     Be clear about the limit: this form posts straight to Shopify, so anything
     POSTing directly to /contact never runs this code at all. These traps stop
     the browser-driven bots, which are most of them; hCaptcha is what stops the
     rest. They are a filter, not a wall. */
  document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
    var hp = form.querySelector('.hp input');
    var born = Date.now();
    var MIN_MS = 3500;
    var warned = null;
    var unlock = 0;

    form.addEventListener('submit', function (e) {
      /* One send at a time: a second click while the first is still going out
         posts, and emails, twice. stopImmediatePropagation as well as
         preventDefault, because Shopify's hCaptcha listener runs after this one
         and sends the form itself whether or not the event was cancelled. */
      if (form.dataset.busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }

      /* filled honeypot = not a person. Fail silently: telling a bot why it was
         blocked is just free debugging for whoever wrote it. */
      if (hp && hp.value.trim() !== '') { e.preventDefault(); return; }

      if (Date.now() - born < MIN_MS) {
        e.preventDefault();
        if (!warned) {
          warned = document.createElement('p');
          warned.className = 'ctc__err';
          warned.setAttribute('role', 'status');
          warned.textContent = 'Give that one more second, then send it again.';
          form.insertBefore(warned, form.firstChild);
        }
        return;
      }
      if (warned) { warned.remove(); warned = null; }

      /* empty honeypot: drop the name so it is never posted and never turns up
         as a blank line in the email Piklo receive */
      if (hp && hp.value.trim() === '') hp.removeAttribute('name');

      /* Lock only a send that is really going out, so look once every listener
         has run. Shopify's captcha bootstrap silently drops a submit made before
         its hCaptcha is bound, and locking then would swallow the retry; a bound
         form (data-hcaptcha-bound) cancels the event but sends the form itself. */
      setTimeout(function () {
        if (e.defaultPrevented && !form.hasAttribute('data-hcaptcha-bound')) return;
        form.dataset.busy = '1';
        clearTimeout(unlock);
        unlock = setTimeout(function () { delete form.dataset.busy; }, 10000);
      }, 0);
    });
    addEventListener('pageshow', function (ev) {   // back/forward cache
      if (ev.persisted) { clearTimeout(unlock); delete form.dataset.busy; }
    });
  });

  /* --- mobile scroll motion --------------------------------------------
     Phones get the static hero, so the whole page used to arrive on one flat
     18px fade. This layer gives each family of elements its own entrance and
     couples two things to the scroll position. It is MOBILE ONLY and it adds
     no payload: every effect is a transform or an opacity that the compositor
     already handles.

     The `mm` class on <html> is the gate. Without JS, on a desktop, or under
     prefers-reduced-motion it is never set and the plain reveal is what runs. */
  var mobile = matchMedia('(max-width: 760px)');
  var motionOn = false;

  /* --- split headings into words -----------------------------------------
     Display type is the loudest thing on this site, and it was arriving on the
     same flat fade as everything else. Splitting it lets each word rise out
     from behind its own line, which is what makes a big Fraunces headline read
     as typeset rather than pasted.

     Three things this has to get right:
       - KEEP THE SPACES. Wrapping words without re-inserting the whitespace
         runs the heading together for a screen reader and for text selection.
       - LEAVE NESTED ELEMENTS ALONE. The sticker word (.wonk / .t-outline) is
         one unit and gets its own motion; it must not be chopped into letters,
         and it must never be masked — its outline and drop shadow live outside
         the text box and a mask would slice them off.
       - <br> stays put, so the hero's two-line break survives. */
  var SPLIT = '.t-d1, .t-d2, .d2, .phero__h1, .ctc__h1, .cmty__askt, .ftr__cta h2';

  function splitWords(el) {
    if (el.dataset.split) return;
    /* FAIL SAFE. The words are moved out of view and only a .reveal ancestor
       going .in brings them back, so a heading with nothing to drive it would
       be stranded off-screen — invisible text on a live page. One heading on
       the homepage was exactly that. If there is no driver, do not split. */
    if (!el.closest('.reveal')) return;
    el.dataset.split = '1';
    var kids = [].slice.call(el.childNodes);
    var i = 0;
    kids.forEach(function (node) {
      if (node.nodeType === 3) {                       // a text node: split it
        /* U+00A0 is not a gap: it holds a unit together ("12 fl oz"), and next
           to an inline-block .sw a line may break even across a no-break space,
           so it stays inside the word. \s alone would split there. */
        var parts = node.textContent.split(/([^\S\xa0]+)/);
        var frag = document.createDocumentFragment();
        parts.forEach(function (part) {
          if (part === '') return;
          if (/^[^\S\xa0]+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var mask = document.createElement('span');
          mask.className = 'sw';
          var inner = document.createElement('span');
          inner.className = 'sw__i';
          inner.textContent = part;
          inner.style.setProperty('--w', i++);
          mask.appendChild(inner);
          frag.appendChild(mask);
        });
        el.replaceChild(frag, node);
      } else if (node.nodeType === 1 && node.tagName !== 'BR') {
        // a nested element — the sticker word. One unit, no mask.
        node.classList.add('sw-solid');
        node.style.setProperty('--w', i++);
      }
    });
    el.classList.add('is-split');
  }

  function setStagger() {
    /* --i on a .reveal is set by the observer (see above, it staggers by
       arrival batch). Only the slab children need numbering up front, because
       they all share one trigger by definition. */
    document.querySelectorAll('[data-stagger]').forEach(function (p) {
      var i = 0;
      [].forEach.call(p.children, function (c) { c.style.setProperty('--i', i++); });
    });
  }

  function enableMotion() {
    if (motionOn) return;
    motionOn = true;
    /* `mo` = the motion vocabulary, on EVERY viewport (Dan, 2026-08-13: every
       page, every element). `mm` is the narrow-screen-only extras on top of
       it — the hero can's scroll drift, and the tighter travel distances. */
    document.documentElement.classList.add('mo');
    if (mobile.matches) document.documentElement.classList.add('mm');
    /* Containers that hand their motion to their children, so a block never
       lands as one slab. Anything with several children that arrive on ONE
       trigger belongs here — heads, button rows, footer columns, the buy
       ticket, the assurance list. */
    document.querySelectorAll(
      '.head.reveal, .phero__in.reveal, .ctc__head.reveal, .btn-row.reveal,' +
      '.ftr__col.reveal, .ftr__cta.reveal, .buybox.reveal, .assure.reveal,' +
      '.cartx__foot.reveal, .pdp__in.reveal, .ftr__base.reveal'
    ).forEach(function (el) { el.setAttribute('data-stagger', ''); });

    document.querySelectorAll(SPLIT).forEach(splitWords);
    setStagger();

    /* ---- scroll-coupled: the hero can ----------------------------------
       One rAF loop, one read of scrollY, one custom property. Nothing reads
       layout inside the loop except a cached midpoint, so it cannot thrash.

       The BACKGROUND is deliberately not part of this. A counter-drift was
       built and then removed on Dan's instruction (2026-08-13) — the slices
       already run their own physics simulation and do not want a second
       motion system layered on top.

       Only the STILL is driven from here. When the spin canvas goes live it
       computes its own --p from its own rect, because by then the still is
       display:none and its midpoint is meaningless. */
    var cans = document.querySelectorAll('.stage4__fallback');
    var canMid = 0, ticking = false;
    var remeasure = function () {
      if (cans[0]) canMid = cans[0].getBoundingClientRect().top + scrollY + cans[0].offsetHeight / 2;
    };
    var frame = function () {
      ticking = false;
      var y = scrollY;
      /* -1 below the fold, 0 dead centre, +1 above it. The spin canvas sets
         its own --p once it goes live; this drives the still until then. */
      var p = (y + innerHeight / 2 - canMid) / innerHeight;
      p = p < -1 ? -1 : p > 1 ? 1 : p;
      for (var i = 0; i < cans.length; i++) cans[i].style.setProperty('--p', p.toFixed(4));
    };
    var onScroll = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    };
    remeasure(); frame();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', function () { remeasure(); setStagger(); frame(); }, { passive: true });
    addEventListener('load', function () { remeasure(); frame(); });
  }

  if (!reduced) enableMotion();

  /* --- PDP gallery ------------------------------------------------------ */
  /* The class fallback keeps the thumbs working if the Liquid hook is lost again:
     a `| default:` in image_tag's arguments once swallowed data-gal-main. */
  var main = document.querySelector('[data-gal-main]') || document.querySelector('.gal__main img');
  if (main) {
    document.querySelectorAll('[data-gal-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('[data-gal-thumb]').forEach(function (x) {
          x.classList.remove('is-on');
          x.setAttribute('aria-pressed', 'false');
        });
        t.classList.add('is-on');
        t.setAttribute('aria-pressed', 'true');
        /* srcset outranks src: swap it too, or the browser keeps showing photo 1 */
        if (t.dataset.srcset) main.srcset = t.dataset.srcset; else main.removeAttribute('srcset');
        main.src = t.dataset.full || t.querySelector('img').src;
        main.alt = t.querySelector('img').alt;
      });
    });
  }
})();
